import React, { useState } from 'react';
import {
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { ILessonPlan } from '../../../../store/DiagnosticSlice';
import { isMobileScreen } from '../../../../helper';

const mainCellStyles: React.CSSProperties = {
  padding: 0,
  borderBottom: 0,
};

const cellStyles: React.CSSProperties = {
  borderLeft: '1px solid lightgray',
};

const headerCellStyles: React.CSSProperties = {
  backgroundColor: '#F1F5F9',
  fontWeight: '600',
  color: '#647488',
};

interface ILessonPlanTable {
  lessonPlan: Array<ILessonPlan>;
}

const LessonPlanTable: React.FC<ILessonPlanTable> = ({ lessonPlan }) => {
  const isMobile = isMobileScreen();
  const [isExpand, setIsExpand] = useState(false);

  const hasSubTopics = lessonPlan.some((plan) =>
    plan.subTopics.some((subtopic) => subtopic.name !== undefined)
  );

  return (
    <div>
      {isMobile ? (
        <>
          {lessonPlan
            .slice(0, isExpand ? lessonPlan.length : 2)
            .map((table) => (
              <TableContainer
                key={table.topic}
                component={Paper}
                sx={{ marginBottom: '15px' }}
              >
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={2}
                        sx={headerCellStyles}
                      >
                        {table.topic}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {table.subTopics.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{ '&:last-child th': { borderBottom: 0 } }}
                      >
                        {hasSubTopics && (
                          <TableCell sx={cellStyles}>{row.name}</TableCell>
                        )}
                        <TableCell align="center" sx={cellStyles}>
                          {row.noOfHours} hour
                          {row.noOfHours > 1 ? 's' : ''}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ))}
        </>
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={headerCellStyles}>Topic</TableCell>
                {hasSubTopics && (
                  <TableCell sx={headerCellStyles}>Sub Topic</TableCell>
                )}
                <TableCell sx={headerCellStyles}>
                  No.of Hours Recommended
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lessonPlan
                .slice(0, isExpand ? lessonPlan.length : 2)
                .map((row) => (
                  <TableRow
                    key={row.topic}
                    sx={{ '&:last-child th': { borderBottom: 0 } }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ fontWeight: '600' }}
                    >
                      {row.topic}
                    </TableCell>
                    {hasSubTopics && (
                      <TableCell sx={mainCellStyles}>
                        <Stack>
                          {row.subTopics.map(
                            (subtopic, index) =>
                              subtopic.name !== undefined && (
                                <TableCell key={index} sx={cellStyles}>
                                  {subtopic.name}
                                </TableCell>
                              )
                          )}
                        </Stack>
                      </TableCell>
                    )}
                    <TableCell sx={mainCellStyles}>
                      <Stack>
                        {row.subTopics.map((subtopic, index) => (
                          <TableCell key={index} sx={cellStyles}>
                            {subtopic.noOfHours} hour
                            {subtopic.noOfHours > 1 ? 's' : ''}
                          </TableCell>
                        ))}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {lessonPlan.length > 2 ? (
        <Stack alignItems="center">
          <Button
            color="inherit"
            endIcon={isExpand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            onClick={() => setIsExpand((prevState) => !prevState)}
            sx={{
              fontWeight: 600,
              marginTop: '10px',
            }}
          >
            View {isExpand ? 'less' : 'more'}
          </Button>
        </Stack>
      ) : null}
    </div>
  );
};

export default LessonPlanTable;
